<template>
  <div class="l-score-list">
    <div class="sound-result" v-if="result">
      <div>本次测评结果为{{ result.word }}</div>
      <p class="l-score-list-message">{{ tip }}</p>

      <div v-if="element" class="my-sound">
        <div>我的心法</div>
        <div v-for="(item, index) in element.records" :key="index">
          <lSoundAudio :src="item.audioUrl"></lSoundAudio>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lSoundAudio from '@/components/l-sound-audio'

export default {
  props: {
    element: {
      type: Object,
    },
    result: {
      type: Object,
    },
  },
  components: {
    lSoundAudio,
  },
  data() {
    return {
      pre: false,
    }
  },
  methods: {
    onDetail() {
      this.pre = !this.pre
    },
  },
}
</script>

<style lang="stylus" scoped>
.l-score-list
  width 100%
  height 100%
  overflow auto
  .l-score-list-message
    display inline-block
    padding 0
    margin 0
    line-height 1.4
    border-bottom solid 1px rgba(255, 255, 255, 0.2)
  h3
    margin 0
    padding 10px 0 10px 0
    font-size 19px
    font-weight 300
.my-sound
  margin-top 10px
</style>
